import { render, staticRenderFns } from "./Mental.vue?vue&type=template&id=498fbc17&"
import script from "./Mental.vue?vue&type=script&lang=js&"
export * from "./Mental.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports